import { render, staticRenderFns } from "./BatchesAssigned.template.vue?vue&type=template&id=99e7a298&scoped=true&"
var script = {}
import style0 from "./BatchesAssigned.template.vue?vue&type=style&index=0&id=99e7a298&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e7a298",
  null
  
)

export default component.exports